import angular from 'npm/angular';
import uiRouter from 'npm/angular-ui-router';
import BaseComponent from './base.component';
import ngMdIcons from 'npm/angular-material-icons';
import register from 'common/register';
import './base.scss';

let baseModule = angular.module('app.components.base', [
    uiRouter,
    ngMdIcons
])

.config(($stateProvider, $urlRouterProvider, $mdDateLocaleProvider) => {
    "ngInject";
    $urlRouterProvider.otherwise('/');

    $stateProvider
        .state('base', {
            abstract: true,
            url: '',
            params: {
                redirect: null,
                showSavePopup: false
            },
            template: '<base></base>'
        });

    $mdDateLocaleProvider.formatDate = function(date) {
        return date ? moment(date).format('DD-MM-YYYY') : '';
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
        var m = moment(dateString, 'DD-MM-YYYY', true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };

});

register('app.components.base').
    directive('base', BaseComponent);

export default baseModule;



// WEBPACK FOOTER //
// ./client/app/components/base/base.js